export enum LostItemStatus {
  LOST = 'Lost',
  FOUND = 'Found',
  HANDED_OVER = 'HandedOver',
}

export enum LostItemCategory {
  BAGS_LUGGAGE = 'Bags/luggage',
  CLOTHING = 'Clothing',
  CURRENCY_MONEY = 'Currency/Money',
  DOCUMENTS = 'Documents',
  TOOLS = 'Tools',
  JEWELLERY = 'Jewellery',
  ANIMAL_PET = 'Animal/pet',
  EQUIPMENT = 'Equipment',
  TICKETS = 'Tickets',
  TOYS = 'Toys',
  PARCEL = 'Parcel',
  OTHER = 'Other',
}
